const translation = {
  // Navbar
  "nav.benefits": "Benefits",
  "nav.mission": "Our Mission",
  "nav.contact": "Contact",
  "nav.cta": "Free Consultation",

  // Hero
  "hero.financing": "Automatic Financing for Churches — 0% Interest",
  "hero.financing.sub": "No banks. No hassle. Grow your ministry without financial pressure.",
  "hero.financing.nobank": "No banks required",
  "hero.financing.approved": "Fast approval",
  "hero.badge": "Premium LED Solutions for Churches",
  "hero.headline1": "More Than Screens.",
  "hero.headline2": "A Worship Experience.",
  "hero.sub": "Transform how your church communicates, connects, and ministers through immersive LED solutions designed for worship.",
  "hero.cta1": "Schedule a Free Consultation",
  "hero.cta2": "See How It Works",
  "hero.scroll": "Scroll to explore",

  // Benefits
  "benefits.badge": "Why AdoraLED",
  "benefits.title1": "Designed for Churches.",
  "benefits.title2": "Built for Impact.",
  "benefits.0.title": "Elevate Worship Atmosphere",
  "benefits.0.desc": "Create immersive environments that help people connect deeply with God. Transform any service into a transcendent, unforgettable experience.",
  "benefits.1.title": "Clear & Engaging Communication",
  "benefits.1.desc": "Make every message, lyric, and visual more impactful and memorable. Your congregation will feel every word, not just hear it.",
  "benefits.2.title": "Turn Visitors into Regular Attendees",
  "benefits.2.desc": "First impressions matter — create an experience people want to return to. A powerful visual environment builds lasting community.",
  "benefits.3.title": "All-in-One Solution",
  "benefits.3.desc": "We handle everything: design, installation, and ongoing support. From the first consultation to the final pixel — we are with you.",
  "benefits.4.title": "Flexible Financing – Zero Interest",
  "benefits.4.desc": "No banks. No hassle. Grow your church without financial pressure. Our financing plans are built around your ministry, not profit.",
  "benefits.cta.title": "Ready to Transform Your Church?",
  "benefits.cta.desc": "Join hundreds of churches that have elevated their worship experience with AdoraLED.",
  "benefits.cta.button": "Get Started Today",

  // Gallery
  "gallery.badge": "Our Installations",
  "gallery.title1": "Real Churches.",
  "gallery.title2": "Real Transformations.",
  "gallery.sub": "See how we have transformed worship spaces across the country with premium LED solutions built for impact.",
  "gallery.cta.text": "Want to see your church transformed like this?",
  "gallery.cta.button": "Get Your Free Consultation",

  // Emotional
  "emotional.quote1": "\"Because worship was never meant to be",
  "emotional.quote2": "just heard\u2026",
  "emotional.quote3": "it was meant to be experienced.\"",
  "emotional.sub1": "This is not about screens.",
  "emotional.sub2": "It\u2019s about creating moments where",
  "emotional.highlight": "lives are transformed.",
  "emotional.stat1.value": "500+",
  "emotional.stat1.label": "Churches Transformed",
  "emotional.stat2.value": "10+",
  "emotional.stat2.label": "Years of Excellence",
  "emotional.stat3.value": "100%",
  "emotional.stat3.label": "Client Satisfaction",

  // Contact
  "contact.badge": "Get in Touch",
  "contact.title1": "Let\u2019s Design the Experience",
  "contact.title2": "for Your Church",
  "contact.intro": "Tell us a bit about your church, and we\u2019ll show you what\u2019s possible. No pressure, just a genuine conversation about your vision.",
  "contact.trust1": "No obligation. Just a conversation.",
  "contact.trust2": "Response within 24 hours.",
  "contact.trust3": "Dedicated specialist for your church.",
  "contact.label.name": "Full Name",
  "contact.label.church": "Church Name",
  "contact.label.email": "Email",
  "contact.label.phone": "Phone / WhatsApp",
  "contact.label.city": "City & State",
  "contact.label.screen_area": "Screen Area (inches or feet)",
  "contact.label.message": "Message (optional)",
  "contact.placeholder.name": "Pastor John Smith",
  "contact.placeholder.church": "Grace Community Church",
  "contact.placeholder.email": "pastor@church.com",
  "contact.placeholder.phone": "+1 (555) 000-0000",
  "contact.placeholder.city": "Houston, TX",
  "contact.placeholder.screen_area": "e.g. 10ft x 6ft or 120in x 72in",
  "contact.placeholder.message": "Tell us about your vision, congregation size, or any questions\u2026",
  "contact.submit": "Request My Free Consultation",
  "contact.sending": "Sending\u2026",
  "contact.trust_note": "No obligation. Just a conversation to explore your vision.",
  "contact.error": "Something went wrong. Please try again.",
  "contact.success.title": "We received your request!",
  "contact.success.desc": "Our team will reach out within 24 hours to schedule your free consultation.",
  "contact.success.another": "Submit another request",

  // Footer
  "footer.tagline": "More Than Screens. A Worship Experience.",
  "footer.copyright": "\u00a9 {year} AdoraLED. All rights reserved. Premium LED Solutions for Churches."
};

export default translation;
